import { GamePlace } from 'constants/cards';
import { COLUMN_Z_INDEX, FOUNDATION_Z_INDEX, STOCK_PILE_Z_INDEX, WAST_PILE_Z_INDEX } from 'constants/layout';
import { Column } from './Column';
import { SolitaireGame } from './SolitaireGame';
import { Layout } from './LayoutManager';
import { Card } from 'components/Card';
import { Foundation } from './Foundation';
import { Store } from './store/gameStore';
import { FreeCell } from './FreeCell';

export function loadCardsTable(solitaireGame: SolitaireGame, onComplete: () => void) {
    const lastTable = Store.gameState;
    Store.reloadLastGame();
    //reload columns

    if (solitaireGame.stockPile) {
        solitaireGame.stockPile.repositionPlaceholder();
        solitaireGame.stockPile.drawPlaceholder();
    }
    lastTable.columns.forEach((column, x) => {
        const newColumn = new Column(solitaireGame, x);
        solitaireGame.columns.push(newColumn);
        column.forEach((card, y) => {
            if (card) {
                const newCard = new Card(card.code);
                newCard.visible = card.visible;
                solitaireGame.cards.push(newCard);
                newColumn.addCard(newCard);
                solitaireGame.gameContainer.addChild(newCard.container);
    
                const cardTargetPosition = solitaireGame.columns[x].getCardPosition(y);
    
                newCard.setPlace({
                    cardPlace: GamePlace.TABLEAU,
                    value: x,
                    zIndex: COLUMN_Z_INDEX + y,
                    position: cardTargetPosition,
                    order: y,
                });
                newCard.changeVisible(card.visible);
                newCard.reset();
            } else {
                solitaireGame.cards.push(null);
                newColumn.addCard(null);
            }
        });
    });
    lastTable.foundation.forEach((f, x) => {
        const foundation = new Foundation(solitaireGame, x);
        solitaireGame.foundations.push(foundation);

        f.forEach((card, y) => {
            const newCard = new Card(card.code);
            newCard.visible = card.visible;
            solitaireGame.cards.push(newCard);
            foundation.addCard(newCard, true);
            solitaireGame.gameContainer.addChild(newCard.container);

            const cardTargetPosition = Layout.getFoundationPosition(x);

            newCard.setPlace({
                cardPlace: GamePlace.FOUNDATION,
                value: x,
                zIndex: FOUNDATION_Z_INDEX + y,
                position: cardTargetPosition,
                order: y,
            });
            newCard.changeVisible(card.visible);
            newCard.reset();
        });
    });
    if (lastTable.freeCells) {
        lastTable.freeCells.forEach((cards, x) => {
            const freeCell = new FreeCell(solitaireGame, x);
            solitaireGame.freeCells.push(freeCell);
            const card = cards.length ? cards[0] : null;
            if (card) {
                const newCard = new Card(card.code);
                newCard.visible = card.visible;
                solitaireGame.cards.push(newCard);
                freeCell.addCard(newCard);
                solitaireGame.gameContainer.addChild(newCard.container);

                const cardTargetPosition = Layout.getFreeCellPosition(x);

                newCard.setPlace({
                    cardPlace: GamePlace.FREECELL,
                    value: x,
                    zIndex: FOUNDATION_Z_INDEX + 1,
                    position: cardTargetPosition,
                    order: 0,
                });
                newCard.changeVisible(card.visible);
                newCard.active = true;
                newCard.reset();
            }
        });
    }
    if (lastTable.stockpile) {
        lastTable.stockpile.forEach((card, x) => {
            const newCard = new Card(card.code);
            newCard.visible = card.visible;
            solitaireGame.cards.push(newCard);
            solitaireGame.stockPile.addCard(newCard);
            solitaireGame.gameContainer.addChild(newCard.container);
            const cardTargetPosition = Layout.getStockPilePosition(50 - lastTable.stockpile.length + x);

            newCard.setPlace({
                cardPlace: GamePlace.STOCKPILE,
                value: lastTable.stockpile.length - x,
                zIndex: STOCK_PILE_Z_INDEX - x,
                position: cardTargetPosition,
                order: x,
            });
            newCard.changeVisible(card.visible);
            newCard.reset();
        });
    }
    if (lastTable.wastePile) {
        lastTable.wastePile.forEach((card, x) => {
            const newCard = new Card(card.code);
            newCard.visible = card.visible;
            solitaireGame.cards.push(newCard);
            solitaireGame.wastePile?.addCard(newCard);
            solitaireGame.gameContainer.addChild(newCard.container);
            const cardTargetPosition = Layout.getWastePilePosition(
                Math.max(0, x - lastTable.wastePile.length + Math.min(lastTable.wastePile.length, 3))
            );

            newCard.setPlace({
                cardPlace: GamePlace.WASTE_PILE,
                value: x,
                zIndex: WAST_PILE_Z_INDEX + x,
                position: cardTargetPosition,
                order: x,
            });
            newCard.changeVisible(card.visible);
            newCard.reset();
        });
    }
    if (solitaireGame.stockPile.length || solitaireGame.wastePile?.length) {
        solitaireGame.stockPile.unblock();
    }
    solitaireGame.refreshBoard();
    if (Store.hasHighlighting()) {
        solitaireGame.columns.forEach((c) => c.refreshHighlight());
    }
    onComplete();
}
